import React, { useEffect, useRef, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { adminDeleteGuidanceFileApi, adminGetUserListForSurveyApi, adminSaveGuidanceCodeApi, adminUploadGuidanceFileApi } from '../../../api/admin/survey'
import { getFileName } from '../../../utils/file/file'
import { FaFileAlt } from 'react-icons/fa'
import './adminSurvey.css'
import { SearchForm } from '../common/SearchForm'
import { swalAlert, swalConfirm, swalErrorAlert } from '../../../utils/swal/swal'
import TablePagination from '../../../components/common/TablePagination'

const AdminSurveyList = () => {
    const location = useLocation();
    const pathname = location.pathname
    const params = new URLSearchParams(location.search);
    const searchTerm = params.get('search')

    return (
        <div className="container-fluid">
            {/* Page Heading */}
            <div className="d-sm-flex align-items-center justify-content-between mb-4">
                <h1 className="h3 mb-0">상담신청 관리</h1>
            </div>

            {/* Content Row */}
            <div className="card shadow mb-4">
                <div className="card-header py-3">
                    <div className='d-flex justify-content-between align-items-center'>
                        <h6 className="m-0 font-weight-bold">학생 리스트</h6>
                        <SearchForm pathname={pathname} searchTerm={searchTerm} placeHolder={'학생 이름을 검색해 주세요.'} />
                    </div>
                </div>

                <div className="card-body" style={{ height: "calc(100vh - 320px)", overflow: "auto" }}>
                    <div className="">
                        <UserListTable searchTerm={searchTerm} />
                    </div>
                </div>

            </div>

        </div>
    )
}

const UserListTable = ({ searchTerm }) => {
    /* States */
    const [userList, setUserList] = useState([])

    /* UseEffect */
    useEffect(() => {
        getUserList(searchTerm)
    }, [searchTerm])

    /* Methods */
    const getUserList = async (searchTerm) => {
        try {
            const response = await adminGetUserListForSurveyApi(searchTerm)
            if (response.data.code === 200) {
                const userList = response.data.resData
                setUserList(userList)
            }
        } catch (error) {
            console.log(error);

            swalErrorAlert('', '상담신청서 사용자 조회 시 에러가 발생했습니다.<br/> 에러가 반복되면 관리자에게 문의해 주세요.')

            setUserList([])
        }
    }

    /* Pagination */
    const itemsPerPage = 6
    const [itemOffset, setItemOffset] = useState(0);
    const endOffset = itemOffset + itemsPerPage;
    const currentItems = userList.slice(itemOffset, endOffset);
    const pageCount = Math.ceil(userList.length / itemsPerPage);
    const handlePageClick = (event) => {
        const newOffset = (event.selected * itemsPerPage) % userList.length;
        setItemOffset(newOffset);
    };

    return (
        <table className={`survey-user-table table table-bordered`} style={{ minWidth: "1501px" }}>
            <colgroup>
                <col width={"100px"} />
                <col width={"200px"} />
                <col width={"150px"} />
                <col width={"350px"} />
                <col width={"200px"} />
                <col width={"350px"} />
                <col width={"150px"} />
            </colgroup>
            <thead>
                <tr className='table-secondary'>
                    <th>학생이름</th>
                    <th>아이디(이메일)</th>
                    <th>설문 수행 여부</th>
                    <th>검사 코드 등록</th>
                    <th>가이던스 수행 여부</th>
                    <th>가이던스 파일 업로드</th>
                    <th>분석 보고서</th>
                </tr>
            </thead>
            <tbody>
                {currentItems &&
                    currentItems.map((user) =>
                        <UserListItem key={'userlist-' + user.user_id} userProp={user} />
                    )}
            </tbody>
            <tfoot>
                <tr>
                    <td colSpan={7}>
                        <div className='text-center'>
                            <TablePagination handlePageClick={handlePageClick} pageCount={pageCount} />
                        </div>
                    </td>
                </tr>
            </tfoot>
        </table>
    )
}


const UserListItem = ({ userProp }) => {
    /* States */
    const [isLoading, setIsLoading] = useState(false)
    const [user, setUser] = useState(userProp ? userProp : null)
    const [fileList, setFileList] = useState(userProp?.files ? userProp?.files : [])

    /* Ref */
    const sltCodeRef = useRef(null)
    const mciCodeRef = useRef(null)
    const fileRef = useRef(null)

    /* Methods */
    const onSaveCode = async (type) => {
        if (isLoading) return;

        const userId = user.user_id
        if (!userId) return false;

        try {
            setIsLoading(true)
            let code = ''
            if (type === 'slt') { code = sltCodeRef.current.value }
            else if (type === 'mci') { code = mciCodeRef.current.value }
            else { return false }

            // api
            const reqData = { userId, code, type }
            const response = await adminSaveGuidanceCodeApi(reqData)
            if (response.data.code === 200) {
                swalAlert("저장 완료", "코드를 성공적으로 저장하였습니다", "success", "확인")
            }
            setIsLoading(false)

        } catch (error) {
            swalErrorAlert()
            setIsLoading(false)
        }
    }

    const onClickUploadFile = async () => {
        if (isLoading) return;

        const userId = user.user_id
        if (!userId) return false;

        if (!fileRef.current || !fileRef.current.files) return;

        const files = Array.from(fileRef.current.files);
        if (files.length === 0) {
            alert("파일을 선택해주세요.");
            return;
        }

        try {
            setIsLoading(true)

            const formData = new FormData();
            files.forEach((file) => formData.append("files", file));
            formData.append('userId', userId)

            const response = await adminUploadGuidanceFileApi(formData)

            if (response.data.code === 200) {
                let newFiles = response.data.resData
                setFileList((prevList) => [...prevList, ...newFiles]); // 기존 목록에 추가

                swalAlert("저장 완료", "파일을 성공적으로 업로드하였습니다", "success", "확인")
            }
            else {
                throw new Error("파일 업로드 실패");
            }

        } catch (error) {
            swalErrorAlert()

        } finally {
            fileRef.current.value = ""; // 파일 업로드 후 초기화
            setIsLoading(false)
            return

        }
    }

    return (
        <tr>
            <td>{user.user_name}</td>
            <td>{user.email}</td>
            <td>
                {user.is_survey_completed ?
                    <div>
                        <div className='text-success mb-2'>O &#40;{user.survey_datetime}&#41;</div>
                        <Link to={`/hy-admin/survey/form/${user.user_id}`} target='_blank' rel="noopener noreferrer" className='btn btn-sm btn-outline-success'>설문지 보기</Link>
                    </div>
                    : <div className='text-danger'>X</div>
                }
            </td>
            <td>
                <div>
                    <div className='input-group input-group-sm mb-3'>
                        <span className="input-group-text">SLT </span>
                        <input className='form-control' ref={sltCodeRef} defaultValue={user.slt_code} placeholder='SLT 코드 입력' />
                        <button type='button' className='btn btn-outline-secondary' onClick={() => onSaveCode('slt')}>저장</button>
                    </div>
                    <div className='input-group input-group-sm'>
                        <span className="input-group-text">MCI </span>
                        <input className='form-control' ref={mciCodeRef} defaultValue={user.mci_code} placeholder='MCI 코드 입력' />
                        <button type='button' className='btn btn-outline-secondary' onClick={() => onSaveCode('mci')}>저장</button>
                    </div>
                </div>
            </td>
            <td>
                <div className='mb-4'>
                    {user.slt_completion
                        ? <div className='text-success'>SLT : O ({user.slt_datetime})</div>
                        : <div className='text-danger'>SLT : X </div>
                    }
                </div>

                <div>
                    {user.mci_completion
                        ? <div className='text-success'>MCI : O ({user.mci_datetime})</div>
                        : <div className='text-danger'>CMI : X </div>
                    }
                </div>
            </td>
            <td>
                <div>
                    <div className='input-group input-group-sm'>
                        <input type='file' className='form-control' ref={fileRef} multiple />
                        <button type='button' className='btn btn-outline-secondary' onClick={onClickUploadFile}>업로드</button>
                    </div>
                    <hr />
                    <FileList fileList={fileList} setFileList={setFileList} user={user} />
                </div>
            </td>
            <td className='text-center'>
                <div className='mb-3'>
                    <Link to={`/hy-admin/survey/report/write/${user.user_id}`} >
                        <button type='button' className='btn btn-sm btn-primary'>보고서 작성</button>
                    </Link>
                </div>

                <div>
                    <Link to={`/hy-admin/survey/report/${user.user_id}`} >
                        <button type='button' className='btn btn-sm btn-outline-secondary'>보고서 조회</button>
                    </Link>
                </div>
            </td>
        </tr>
    )
}


const FileList = ({ fileList, setFileList, user }) => {

    useEffect(() => {
        setFileList(fileList)
    }, [fileList])

    const userId = user.user_id
    const deleteFile = async (file, userId) => {
        swalConfirm('파일 삭제', '파일을 삭제하시겠습니까?', 'question', '삭제', '취소',
            async () => {
                try {
                    const requestData = { file, userId }
                    const response = await adminDeleteGuidanceFileApi(requestData)
                    if (response?.data?.code === 200) {
                        swalAlert('파일 삭제', '파일을 삭제했습니다.', 'success', '확인')

                        setFileList((prev) => {
                            return prev.filter(item => file != item)
                        })
                    }

                } catch (error) {
                    console.log(error);
                    swalErrorAlert('파일 삭제 에러', '파일을 삭제하는 도중에 에러가 발생했습니다.')
                }
                return
            },
            () => { return }
        )

    }

    return (
        <ul>
            {fileList &&
                fileList.map((file, idx) => {
                    let fileName = getFileName('survey', file)
                    return (
                        <>
                            <li key={'user-list-file-' + user.user_id + '-' + idx} className='mb-2'>
                                <a href={file} download={fileName}>
                                    <FaFileAlt /> {fileName}
                                </a>

                                &nbsp;

                                <button type='button' className='btn btn-sm text-danger' onClick={() => deleteFile(file, userId)}>X</button>
                            </li>
                        </>
                    )
                })
            }
        </ul>
    )

}

export default AdminSurveyList